//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { StudentNameDisplayItem } from './StudentNameDisplayItem';
import { TeacherNameDisplayItem } from './TeacherNameDisplayItem';
import { EventColorEnum, TagType } from './Enums';

export class TagDisplayItem extends ItemBase {
    ID: string | null = null;
    Name: string | null = null;
    Description: string | null = null;
    Color: EventColorEnum = EventColorEnum.Beach;
    Type: TagType = TagType.Group;
    StudentCount: number = 0;
    ActiveStudentCount: number | null = null;
    TeacherCount: number = 0;
    ActiveTeacherCount: number | null = null;
    Students: StudentNameDisplayItem[] = [];
    StudentIDs: string[] = [];
    Teachers: TeacherNameDisplayItem[] = [];
    TeacherIDs: string[] = [];

    constructor(initializer?: Partial<TagDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TagDisplayItem";
}
